import React, { PropTypes } from 'react';

/**
 * External link presentational component.
 * Wraps links with target and rel attributes to open safely in a new window.
 */
const ExternalLink = props => (
  <a target="_blank" rel="noopener noreferrer nofollow" {...props}>
    {props.children}
  </a>
);

ExternalLink.propTypes = {
  /**
   * Children contents of the link.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default ExternalLink;



// WEBPACK FOOTER //
// ./app/src/components/ExternalLink/index.jsx